import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitCurrency = createSelector(
  [selectFinancialCockpitState],
  ({ selectedCurrency }) => selectedCurrency
)
